import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../main/main.styles';
import { mixinScreen, pageContainerStyles } from '../../styles';

export const WelcomeStyles = css`
  ${MainStyles}
  :host {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    overflow: hidden;

    ${mixinScreen('flex')
  }

  .container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 100%;
    width: calc(100% - 32px);
    padding: 10px;
    background-color: #181a1f;

    ${pageContainerStyles}; 
  }
`;
